import _ from "lodash";
/**--external-- */
import { graphql } from "lib/apolloClient";
import {
  CURRICULUM_TYPE_PYP,
  PLANNER_ELEMENT_NESTED_CHECKLIST,
} from "Constants/stringConstants";

/**--relative-- */
import { getPlannerElementSetsOfCurriculumQuery } from "./PlannerElementDataSetQueries";

const getPlannerElementSetsOfCurriculumVariables = ({
  curriculumId,
  curriculumNodeInterfaceType,
  plannerElementTypes,
  filters,
  portalType = "PLANNER",
}) => {
  return {
    id: curriculumId,
    type: curriculumNodeInterfaceType,
    elementTypes: plannerElementTypes,
    portalType,
    ...(!_.isEmpty(filters) && { filters }),
  };
};

export const getPlannerElementSetsOfCurriculumEnhancer = graphql(
  getPlannerElementSetsOfCurriculumQuery,
  {
    name: "getPlannerElementSetsOfCurriculum",
    skip: ({ curriculumType, plannerElementTypes, skipQuery }) =>
      _.isEqual(curriculumType, CURRICULUM_TYPE_PYP) ||
      _.isEmpty(plannerElementTypes) ||
      _.includes(plannerElementTypes, PLANNER_ELEMENT_NESTED_CHECKLIST) ||
      !!skipQuery,
    options: ({
      curriculumId,
      plannerElementTypes,
      curriculumNodeInterfaceType,
      filters,
      portalType,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: getPlannerElementSetsOfCurriculumVariables({
        curriculumId,
        curriculumNodeInterfaceType,
        plannerElementTypes,
        filters,
        portalType,
      }),
    }),
    props({
      getPlannerElementSetsOfCurriculum,
      ownProps: { isData, isLoading },
    }) {
      const data = _.get(getPlannerElementSetsOfCurriculum, "node", {});
      const plannerElementNodes = _.get(
        data,
        "plannerElementSets[0].nodes",
        []
      );
      return {
        plannerElementNodes,
        isData: !_.isEmpty(data) && isData,
        isLoading:
          getPlannerElementSetsOfCurriculum["networkStatus"] == 1 ||
          getPlannerElementSetsOfCurriculum["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }
);
